import {
  Accordion,
  Divider,
  AccordionDetails,
  Grid,
  Typography,
  useEventCallback,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps, FormikErrors, FormikTouched } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import SelectLogicOperation from 'shell/components/shared/select-choice';
import { list, listEqualOperator, listNameOperator } from 'shell/constants/select-choice-operator';
import SelectSerie from 'civil-status/components/shared/select-serie';
import { CertificateType, CertificationFormVM } from 'front-office/view-models/document-birth-form';
import { DocumentMarriageFilterFormCertification } from 'civil-status/view-models/document-marriage-list';
import NumberAct from 'civil-status/components/shared/number-act';
import AutocompleteRegistry from 'civil-status/components/shared/autocomplete-registry';

interface FiltersDocumentProps {
  filterDocumentForm: FormikProps<CertificationFormVM>;
  handleSearch: (form?: DocumentMarriageFilterFormCertification | null) => void;
}

const FilterDocument = ({
  filterDocumentForm,
  handleSearch,
}: FiltersDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const onChange = useEventCallback(
    (
      key: keyof DocumentMarriageFilterFormCertification,
      value: DocumentMarriageFilterFormCertification[keyof DocumentMarriageFilterFormCertification]
    ) => {
      filterDocumentForm.setFieldValue('documentSearch', {
        ...(filterDocumentForm.values.documentSearch || {}),
        [key]: value,
      });
    }
  );
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-search-document-filters-content"
        id="panel-search-document-filters-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterDocumentForm.handleSubmit} onReset={filterDocumentForm.handleReset}>
          <Grid container spacing={2} style={{ paddingTop: '0px' }}>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  size="small"
                  label="Anno"
                  aria-label="Anno"
                  id="year"
                  fullWidth
                  inputProps={{
                    maxLength: '4',
                  }}
                  onChange={(event) => {
                    onChange('year', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.year || ''}
                  helperText={
                    (
                      filterDocumentForm.errors
                        .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                    )?.year
                  }
                  error={
                    (
                      filterDocumentForm.touched
                        .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                    )?.year &&
                    Boolean(
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.year
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-year"
                  onChange={(event) => {
                    onChange('operationYear', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.operationYear || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              {filterDocumentForm.values.documentSearch?.operationDocument === '1' ? (
                <>
                  <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                    <NumberAct
                      size="small"
                      fullWidth
                      label="Atto"
                      aria-label="Atto"
                      id="from-document"
                      onChange={(event) => {
                        onChange('fromDocument', event?.target.value);
                      }}
                      onBlur={(value) => {
                        onChange('fromDocument', value);
                      }}
                      inputProps={{
                        maxLength: '4',
                      }}
                      value={filterDocumentForm.values.documentSearch?.fromDocument || ''}
                      helperText={
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.fromDocument
                      }
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification> as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.fromDocument &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.fromDocument
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4} style={{ paddingTop: '10px' }}>
                    <NumberAct
                      size="small"
                      label="e il"
                      aria-label="e il"
                      fullWidth
                      id="document-e-il"
                      onChange={(event) => {
                        onChange('toDocument', event?.target.value);
                      }}
                      onBlur={(value) => {
                        onChange('toDocument', value);
                      }}
                      inputProps={{
                        maxLength: '4',
                      }}
                      value={filterDocumentForm.values.documentSearch?.toDocument || ''}
                      helperText={
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.toDocument
                      }
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.toDocument &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.toDocument
                        )
                      }
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                  <NumberAct
                    size="small"
                    label="Atto"
                    aria-label="Atto"
                    fullWidth
                    id="document"
                    onChange={(event) => {
                      onChange('document', event?.target.value);
                    }}
                    onBlur={(value) => {
                      onChange('document', value);
                    }}
                    inputProps={{
                      maxLength: '4',
                    }}
                    value={filterDocumentForm.values.documentSearch?.document || ''}
                    helperText={
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.document
                    }
                    error={
                      (
                        filterDocumentForm.touched
                          .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                      )?.document &&
                      Boolean(
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.document
                      )
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={list}
                  id="operation-document"
                  onChange={(event) => {
                    onChange('operationDocument', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.operationDocument || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              {filterDocumentForm.values.documentSearch?.operationRegistry === '1' ? (
                <>
                  <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                    <AutocompleteRegistry
                      label="Registro"
                      id="from-registry"
                      onChange={(value) => {
                        onChange('fromRegistry', value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.fromRegistry || null}
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.fromRegistry &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.fromRegistry
                        )
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{ paddingTop: '10px' }}
                    display="flex"
                    alignItems="center"
                  >
                    <AutocompleteRegistry
                      label="e il"
                      id="to-registry"
                      onChange={(value) => {
                        onChange('toRegistry', value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.toRegistry || null}
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.toRegistry &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.toRegistry
                        )
                      }
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                  <AutocompleteRegistry
                    label="Registro"
                    id="registry"
                    onChange={(value) => {
                      onChange('registry', value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.registry || null}
                    error={
                      (
                        filterDocumentForm.touched
                          .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                      )?.registry &&
                      Boolean(
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.registry
                      )
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={list}
                  id="operation-registry"
                  onChange={(event) => {
                    onChange('operationRegistry', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.operationRegistry || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  size="small"
                  label="Parte"
                  aria-label="Parte"
                  fullWidth
                  id="portion"
                  onChange={(event) => {
                    onChange('portion', event?.target.value);
                  }}
                  inputProps={{
                    maxLength: '2',
                  }}
                  value={filterDocumentForm.values.documentSearch?.portion || ''}
                  helperText={
                    (
                      filterDocumentForm.errors
                        .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                    )?.portion
                  }
                  error={
                    (
                      filterDocumentForm.touched
                        .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                    )?.portion &&
                    Boolean(
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.portion
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-portion"
                  onChange={(event) => {
                    onChange('operationPortion', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.operationPortion || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <SelectSerie
                  isSmallSize
                  label="Serie"
                  id="serie"
                  onChange={(event) => {
                    onChange('serie', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.serie || ''}
                  error={
                    (
                      filterDocumentForm.touched
                        .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                    )?.serie &&
                    Boolean(
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.serie
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-serie"
                  onChange={(event) => {
                    onChange('operationSerie', event?.target.value);
                  }}
                  value={filterDocumentForm.values.documentSearch?.operationSerie || ''}
                />
              </Grid>
            </Grid>
            {filterDocumentForm.values.certificate?.type === CertificateType.matrimonio ||
            filterDocumentForm.values.certificate?.type === CertificateType.unioneCivile ? (
              <>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                  <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                    <PmiTextField
                      size="small"
                      label="Matricola"
                      aria-label="Matricola"
                      fullWidth
                      id="matricolaHusband"
                      inputProps={{
                        maxLength: '7',
                      }}
                      onChange={(event) => {
                        onChange('matricolaHusband', event?.target.value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.matricolaHusband || ''}
                      helperText={
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.matricolaHusband
                      }
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.matricolaHusband &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.matricolaHusband
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                    <SelectLogicOperation
                      isSmallSize
                      list={listEqualOperator}
                      id="operation-matricola-husband"
                      onChange={(event) => {
                        onChange('operationMatricolaHusband', event?.target.value);
                      }}
                      value={
                        filterDocumentForm.values.documentSearch?.operationMatricolaHusband || ''
                      }
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                  <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                    <PmiTextField
                      size="small"
                      label="Cognome"
                      aria-label="Cognome"
                      fullWidth
                      id="surnameHusband"
                      onChange={(event) => {
                        onChange('surnameHusband', event?.target.value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.surnameHusband || ''}
                      helperText={
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.surnameHusband
                      }
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.surnameHusband &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.surnameHusband
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                    <SelectLogicOperation
                      isSmallSize
                      list={listNameOperator}
                      id="operation-surname-husband"
                      onChange={(event) => {
                        onChange('operationSurnameHusband', event?.target.value);
                      }}
                      value={
                        filterDocumentForm.values.documentSearch?.operationSurnameHusband || ''
                      }
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                  <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                    <PmiTextField
                      size="small"
                      label="Nome"
                      aria-label="Nome"
                      fullWidth
                      id="nameHusband"
                      onChange={(event) => {
                        onChange('nameHusband', event?.target.value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.nameHusband || ''}
                      helperText={
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.nameHusband
                      }
                      error={
                        (
                          filterDocumentForm.touched
                            .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                        )?.nameHusband &&
                        Boolean(
                          (
                            filterDocumentForm.errors
                              .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                          )?.nameHusband
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                    <SelectLogicOperation
                      isSmallSize
                      list={listNameOperator}
                      id="operation-name-husband"
                      onChange={(event) => {
                        onChange('operationNameHusband', event?.target.value);
                      }}
                      value={filterDocumentForm.values.documentSearch?.operationNameHusband || ''}
                    />
                  </Grid>
                </Grid>
              </>
            ) : undefined}
            <>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                  <PmiTextField
                    size="small"
                    label="Matricola"
                    aria-label="Matricola"
                    fullWidth
                    id="matricolaWife"
                    inputProps={{
                      maxLength: '7',
                    }}
                    onChange={(event) => {
                      onChange('matricolaWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.matricolaWife || ''}
                    helperText={
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.matricolaWife
                    }
                    error={
                      (
                        filterDocumentForm.touched
                          .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                      )?.matricolaWife &&
                      Boolean(
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.matricolaWife
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                  <SelectLogicOperation
                    isSmallSize
                    list={listEqualOperator}
                    id="operation-matricola-wife"
                    onChange={(event) => {
                      onChange('operationMatricolaWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.operationMatricolaWife || ''}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                  <PmiTextField
                    size="small"
                    label="Cognome"
                    aria-label="Cognome"
                    fullWidth
                    id="surnameWife"
                    onChange={(event) => {
                      onChange('surnameWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.surnameWife || ''}
                    helperText={
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.surnameWife
                    }
                    error={
                      (
                        filterDocumentForm.touched
                          .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                      )?.surnameWife &&
                      Boolean(
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.surnameWife
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                  <SelectLogicOperation
                    isSmallSize
                    list={listNameOperator}
                    id="operation-surname-wife"
                    onChange={(event) => {
                      onChange('operationSurnameWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.operationSurnameWife || ''}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
                <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                  <PmiTextField
                    size="small"
                    label="Nome"
                    aria-label="Nome"
                    fullWidth
                    id="nameWife"
                    onChange={(event) => {
                      onChange('nameWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.nameWife || ''}
                    helperText={
                      (
                        filterDocumentForm.errors
                          .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                      )?.nameWife
                    }
                    error={
                      (
                        filterDocumentForm.touched
                          .documentSearch as FormikTouched<DocumentMarriageFilterFormCertification>
                      )?.nameWife &&
                      Boolean(
                        (
                          filterDocumentForm.errors
                            .documentSearch as FormikErrors<DocumentMarriageFilterFormCertification>
                        )?.nameWife
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                  <SelectLogicOperation
                    isSmallSize
                    list={listNameOperator}
                    id="operation-name-wife"
                    onChange={(event) => {
                      onChange('operationNameWife', event?.target.value);
                    }}
                    value={filterDocumentForm.values.documentSearch?.operationNameWife || ''}
                  />
                </Grid>
              </Grid>
            </>
          </Grid>
          <div className="pmi-pt-4 pmi-text-md-end">
            <div className="pmi-pr-md-4 pmi-pb-4 pmi-pb-md-0 pmi-d-md-inline-block pmi-d-block pmi-w-md-15">
              <PmiButton
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() => handleSearch(filterDocumentForm.values.documentSearch)}
              >
                Cerca
              </PmiButton>
            </div>
            <div className="pmi-pr-md-4 pmi-pb-4 pmi-pb-md-0 pmi-d-md-inline-block pmi-d-block pmi-w-md-15">
              <PmiButton
                variant="outlined"
                color="cdmBrandSecondary"
                fullWidth
                onClick={() =>
                  filterDocumentForm.setValues({
                    ...filterDocumentForm.values,
                    documentSearch: {
                      page: 0,
                      rowsPerPage: 10,
                      orders: {},
                      year: '',
                      document: '',
                      registry: null,
                      portion: '',
                      serie: '',
                      matricolaHusband: '',
                      surnameHusband: '',
                      nameHusband: '',
                      matricolaWife: '',
                      surnameWife: '',
                      nameWife: '',
                      operationYear: '0',
                      operationDocument: '0',
                      operationRegistry: '0',
                      operationPortion: '0',
                      operationSerie: '0',
                      operationMatricolaHusband: '0',
                      operationSurnameHusband: '0',
                      operationNameHusband: '0',
                      operationMatricolaWife: '0',
                      operationSurnameWife: '0',
                      operationNameWife: '0',
                    },
                  })
                }
              >
                Pulisci
              </PmiButton>
            </div>
          </div>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterDocument.displayName = 'Filters Document component';

export default FilterDocument;
